/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from '@/components/button'
import { MainContent } from '@/components/content'
import { ArrowBack } from '@/components/icons'
import { MainLayout } from '@/components/layouts'
import { MainSidebar, MobileSidebar } from '@/components/sidebar'
import { ROUTE_EVENTS } from '@/constants/Routes'
import { useAppDispatch, useAppSelector } from '@/hooks/useRedux'
import { getClubRoles } from '@/pages/club/clubSlice'
import { appSelector } from '@/pages/home/selectors'
import { userSelector } from '@/pages/user/selectors'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Detail, DetailHeader } from '../components'
import { getEventDetail } from '../eventSlice'
import { eventSelector } from '../selectors'

export const EventDetail = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const params = useParams()
  const dispatch = useAppDispatch()
  const { isShowDropdown } = useAppSelector(appSelector)
  const { user } = useAppSelector(userSelector)
  const { event } = useAppSelector(eventSelector)

  const { eventId } = params

  const handleBack = () =>
    navigate(ROUTE_EVENTS, {
      state: {
        goBackEvent: true,
      },
    })

  useEffect(() => {
    if (eventId) dispatch(getEventDetail(eventId))
  }, [eventId])

  useEffect(() => {
    if (event?.clubId && user?.id) {
      dispatch(getClubRoles({ clubId: event?.clubId, userId: user?.id }))
    }
  }, [event, user])

  return (
    <>
      {!isShowDropdown && <MobileSidebar />}

      <MainLayout>
        <MainSidebar />
        <MainContent>
          <div className="flex flex-col gap-y-6 md:gap-y-8 mb-20 lg:mb-8">
            <div className="flex items-center">
              <Button onClick={handleBack} className="hover:opacity-50">
                <ArrowBack className="text-white" />
              </Button>
              <h1 className="ml-3 text-sm md:text-xl text-white font-semibold">{t('club.eventDetails')}</h1>
            </div>

            <DetailHeader />

            <Detail />
          </div>
        </MainContent>
      </MainLayout>
    </>
  )
}
